import $ from "jquery"

function sectionIndicatorId(){
    const sectionIndicatorArr = [];

    $('.page-template-ehealth .section__indicator, .page-template-ecommerce .section__indicator, .single-seo_audits .section__indicator').each(function(){
        const distanceSection = $(this).offset().top - $('.header').outerHeight();
        const windowElem = $(window);
        const sectionIndicatorId = $(this).attr('id');

        if(windowElem.scrollTop() >= distanceSection ) {
            if (!sectionIndicatorArr.includes(sectionIndicatorId)) {
                sectionIndicatorArr.push(sectionIndicatorId);
            }
        }
    });

    return sectionIndicatorArr[sectionIndicatorArr.length - 1];
}

function activeNavMenuSwitcher(elem){
    const linkAttr = $(elem).attr('href');
    const parseLinkAttr = linkAttr.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '');

    if(parseLinkAttr == sectionIndicatorId()){
        $(elem).addClass('active');
    }else{
        $(elem).removeClass('active');
    }
}

function activeNavMenuOnLoadScroll(elem){
    const linkAttr = $(elem).attr('href');
    const parseLinkAttr = linkAttr.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '');

    if(parseLinkAttr == window.location.hash){
        $('html, body').animate({
            scrollTop: $(window.location.hash).offset().top
        }, 'slow');
    }
}

$(window).on('scroll', function(){
    $('.page-template-ehealth .nav-link, .page-template-ecommerce .nav-link, .single-seo_audits .nav-link').each(function(){
        activeNavMenuSwitcher(this);
    });

    $('.page-template-ehealth .navbar-cta__link, .page-template-ecommerce .navbar-cta__link, .single-seo_audits .navbar-cta__link').each(function(){
        activeNavMenuSwitcher(this);
    });

    $('.page-template-ehealth .footer__top-menu a, .page-template-ecommerce .footer__top-menu a, .single-seo_audits .footer__top-menu a').each(function(){
        activeNavMenuSwitcher(this);
    });
});

$(window).on('load', function() {
    $('.page-template-ehealth .nav-link, .page-template-ecommerce .nav-link, .single-seo_audits .nav-link').each(function(){
        activeNavMenuOnLoadScroll(this);
    });

    $('.page-template-ehealth .footer__top-menu a, .page-template-ecommerce .footer__top-menu a, .single-seo_audits .footer__top-menu a').each(function(){
        activeNavMenuOnLoadScroll(this);
    });
});